import { Injectable } from '@angular/core';
import { SDAngularJsonAPIRequestService } from './sd-angular-jsonapi-request.service';
import { JSONAPIResource } from '../utils/sd-angular-jsonapi-resource';
import { SDAngularJsonAPIConfig } from '../interfaces/config';
import { PaginationStrategy } from '../interfaces/pagination-strategy';
import { PaginationOptions } from '../interfaces/pagination-options';
import { find } from 'lodash';
import { JSONAPIError } from '../utils/sd-angular-jsonapi-error';
import { JSON_API_ERROR_MESSAGES } from '../utils/error-messages';

@Injectable()
export class EntityManager {

	entities: any[] = [];

	constructor (public request: SDAngularJsonAPIRequestService) {}

	configure (config: SDAngularJsonAPIConfig) {
		if ( config ) {
			this.request.configure(config);
		}
		return this;
	}

	setBaseUrl (url: string): EntityManager {
		this.request.setBaseUrl(url);
		return this;
	}

	baseUrl (url: string): EntityManager {
		this.request.setBaseUrl(url);
		return this;
	}

	setVersion (version: string): EntityManager {
		this.request.setVersion(version);
		return this;
	}

	version (version: string): EntityManager {
		this.request.setVersion(version);
		return this;
	}

	setPaginationStrategy (strategy: PaginationStrategy): EntityManager {
		this.request.setPaginationStrategy(strategy);
		return this;
	}

	paginationStrategy (strategy: PaginationStrategy): EntityManager {
		this.request.setPaginationStrategy(strategy);
		return this;
	}

	getPaginationStrategy (): PaginationStrategy {
		return this.request.getPaginationStrategy();
	}

	paginationStrategySet (): boolean {
		return this.request.paginationStrategySet();
	}

	setPaginationOptions (options: PaginationOptions): EntityManager {
		this.request.setPaginationOptions(options);
		return this;
	}

	paginationOptions (options: PaginationOptions): EntityManager {
		this.request.setPaginationOptions(options);
		return this;
	}

	getPaginationOptions (): PaginationOptions {
		return this.request.getPaginationOptions();
	}

	paginationOptionsSet (): boolean {
		return this.request.paginationOptionsSet();
	}

	createResource<R extends JSONAPIResource> (resourceType: new() => R, config?: SDAngularJsonAPIConfig): R {
		if ( config ) {
			this.configure(config);
		}
		const resource = new resourceType();
		resource.manager = this;
		resource.initialize();
		this.entities.push(resource);
		return resource;
	}

	refreshByIndex (index: number): void {
		const resource = this.entities[ index ];
		if ( resource ) {
			resource.refresh();
		} else {
			throw new JSONAPIError(JSON_API_ERROR_MESSAGES.RESOURCE_NOT_REGISTERED);
		}
	}

	reloadByIndex (index: number): void {
		this.refreshByIndex(index);
	}

	refreshById (id: number | string): void {
		const resource = find(this.entities, { id });
		if ( resource ) {
			resource.refresh();
		} else {
			throw new JSONAPIError(JSON_API_ERROR_MESSAGES.RESOURCE_NOT_REGISTERED);
		}
	}

	reloadById (id: number | string): void {
		this.refreshById(id);
	}
}
